import { cn } from "@/utils";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

export function RadioGroupRoot({
  children,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <form>
      <RadioGroupPrimitive.Root {...props}>{children}</RadioGroupPrimitive.Root>
    </form>
  );
}

export function RadioGroupItem({
  id,
  value,
  children,
  className,
  containerProps,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  value: string;
  containerProps?: React.ComponentProps<"div">;
}) {
  return (
    <div className="flex items-center" {...containerProps}>
      <RadioGroupPrimitive.Item
        className={cn(
          "size-5 cursor-default rounded-full border-2 border-black bg-white outline-none focus:shadow-black data-[state=checked]:border-[#5181B8] data-[state=checked]:scale-90 data-[state=checked]:border-1",
          className
        )}
        value={value}
        id={id}
        {...props}
      >
        <RadioGroupPrimitive.Indicator className="relative flex size-full items-center justify-center after:block after:size-[11px] after:rounded-full after:bg-[#5181B8]" />
      </RadioGroupPrimitive.Item>
      {children}
    </div>
  );
}

export function RadioLabel({ children, htmlFor, className, ...props }: React.ComponentProps<"label">) {
  return (
    <label className={cn("pl-4 leading-none text-black", className)} htmlFor={htmlFor} {...props}>
      {children}
    </label>
  );
}
